import { Box, Button, Container, Icon, styled, Typography } from '@mui/material';

export const EmptyContainer = styled(Container)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(18)
}));

export const LetterIconBackground = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.success.secondary,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    height: 96,
    width: 96,
    marginBottom: theme.spacing(2)
}));

export const LetterIcon = styled(Icon)(({ theme }) => ({
    color: theme.palette.success.main,
    fontSize: 56
}));

export const EmptyText = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(16)
}));

export const GroupedHeader = styled(Typography)(({ theme }) => ({
    fontSize: `${theme.typography.pxToRem(10)} !important`,
    letterSpacing: '1.5px',
    lineHeight: '18px',
    fontWeight: 'medium',
    paddingLeft: theme.spacing(2)
}));

export const LetterMetaData = styled(Typography)(({ theme }) => ({
    fontSize: theme.typography.pxToRem(14),
    fontStyle: 'italic'
}));

export const NewLetterButton = styled(Button)(() => ({
    width: 234,
    height: 40,
    textTransform: 'inherit'
}));
